// assets
import { MenuIcon } from 'components/ui-component/icons';

// ==============================|| ALL MENU ITEMS ||============================== //

const all_nav = [{
    id: 'basic-info',
    title: '고객서비스',
    type: 'group',
    icon: () => <MenuIcon size="20px" />,
    children: [
        {
            id: 'service-info',
            title: '서비스 소개',
            type: 'item',
            icon: () => <MenuIcon size="20px" />,
            url: '/service-info/'
        },
        // {
        //     id: 'faq',
        //     title: '자주 묻는 질문',
        //     type: 'item',
        //     icon: () => <MenuIcon size="20px" />,
        //     url: '/faq/'
        // },
        {
            id: 'privacy',
            title: '개인정보 처리방침',
            type: 'item',
            icon: () => <MenuIcon size="20px" />,
            url: '/privacy/'
        }
    ]
}
];

export default all_nav;
